import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useNavigationStore } from '@/stores/navigationStore'
import { useBubblesStore } from '@/stores/bubbles'
import type { Bubble } from '@/stores/interfaces'

export function useTypeNavigation(bubble: Bubble) {
  const navigationStore = useNavigationStore()
  const bubblesStore = useBubblesStore()
  const router = useRouter()

  async function setupNavigation() {
    // Set current type
    navigationStore.setCurrentType(bubble.type)

    // Fetch all bubbles of this type if not already loaded
    if (
      !bubblesStore.bubblesByType[bubble.type] ||
      bubblesStore.bubblesByType[bubble.type].length <= 1
    ) {
      await bubblesStore.fetchBubblesByType(bubble.type)
    }

    // Get all UUIDs for this type and set them in the navigation store
    const typeItems = bubblesStore.bubblesByType[bubble.type]?.map((b) => b.uuid) || []
    navigationStore.setCurrentTypeItems(typeItems)
  }

  function handleKeydown(event: KeyboardEvent) {
    // Only handle navigation if not typing in an input or textarea
    if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
      return
    }

    if (event.key === 'ArrowLeft') {
      const previousUuid = navigationStore.getPreviousItem(bubble.uuid)
      if (previousUuid) {
        router.push(`/bubble/${previousUuid}`)
      }
    } else if (event.key === 'ArrowRight') {
      const nextUuid = navigationStore.getNextItem(bubble.uuid)
      if (nextUuid) {
        router.push(`/bubble/${nextUuid}`)
      }
    }
  }

  onMounted(async () => {
    await setupNavigation()
    window.addEventListener('keydown', handleKeydown)
  })

  onUnmounted(() => {
    window.removeEventListener('keydown', handleKeydown)
  })

  return {
    setupNavigation,
  }
}
